package ru.malygin.dateTime

import kotlinx.datetime.*
import kotlinx.datetime.format.*
import ru.malygin.myConst.TimeDetectorItem
import ru.malygin.myConst.WeekDay
import ru.malygin.myConst.toWeekDay
import utils.logger.log

class WhatDay(

)
{
    private val zone = TimeZone/*.currentSystemDefault()*/.of("UTC+5")
    private val currentDayNotFormat = Clock.System.now().toLocalDateTime(zone)

    private val tempCurrentDayTime = LocalDateTime.Format {
        hour()
        char(':')
        minute()
    }.format(currentDayNotFormat)

    // => 08.01
    val open_currentDay = LocalDateTime.Format {
        dayOfMonth(/*padding = Padding.NONE*/)
        char('.')
        monthNumber(/*padding = Padding.NONE*/)
    }.format(currentDayNotFormat)

    // => 12.10
    val open_currentTime = LocalDateTime.Format {
        hour()
        char(':')
        minute()
    }.format(currentDayNotFormat)

    fun returnWeekDay(): List<TimeDetectorItem>{
        return if ((
                    (currentDayNotFormat.dayOfWeek == DayOfWeek.SATURDAY) && (tempCurrentDayTime >  "19:15")
                ) || currentDayNotFormat.dayOfWeek == DayOfWeek.SUNDAY) {
            val ll = returnNextWeekDay()
//            log.i("return next week $ll")
            ll
        }else{
            val ll = returnThisWeekDay()
//            log.i("return this week $ll")
            ll
        }
    }



    private fun returnThisWeekDay(): List<TimeDetectorItem> {
        val timeDetectorList = mutableListOf<TimeDetectorItem>()
        val today = currentDayNotFormat.date
        val todayWeekDay = today.dayOfWeek.isoDayNumber
        val weekDay = (1..6).map {
            today.plus(it - todayWeekDay, DateTimeUnit.DAY)
        }

        weekDay.forEach { day ->
            val dateFormat = LocalDate.Format {
                dayOfMonth(padding = Padding.NONE)
                char('_')
                monthName(RUSSIAN_MONTH_NAME_ABBREVIATED)
                char(' ')
                dayOfMonth()
                char('.')
                monthNumber()
                char('.')
                year()
                char(' ')
                dayOfMonth(padding = Padding.NONE)
            }.format(day)
            timeDetectorList.add(
                TimeDetectorItem(
                    targetDay = if (day.dayOfWeek == today.dayOfWeek) 1 else 0,
                    dateAndNameOfDay = dateFormat.split(" ")[0],
                    onlyDateOfDay = dateFormat.split(" ")[1],
                    nameOfDay = day.dayOfWeek.toWeekDay(),
                    dayByNumber = dateFormat.split(" ")[2]
                )
            )
        }
        return timeDetectorList.toList()
    }

    private fun returnNextWeekDay(): List<TimeDetectorItem> {
        val timeDetectorList = mutableListOf<TimeDetectorItem>()
        val today = currentDayNotFormat.date.plus(period = DatePeriod(0, 0, 7))
        val todayWeekDay = today.dayOfWeek.isoDayNumber
        val weekDay = (1..6).map {
            today.plus(it - todayWeekDay, DateTimeUnit.DAY)
        }

        weekDay.forEach { day ->
            val dateFormat = LocalDate.Format {
                dayOfMonth(padding = Padding.NONE)
                char('_')
                monthName(RUSSIAN_MONTH_NAME_ABBREVIATED)
                char(' ')
                dayOfMonth()
                char('.')
                monthNumber()
                char('.')
                year()
                char(' ')
                dayOfMonth(padding = Padding.NONE)
            }.format(day)
            timeDetectorList.add(
                TimeDetectorItem(
                    targetDay = if (day.dayOfWeek.isoDayNumber == 1) 1 else 0,
                    dateAndNameOfDay = dateFormat.split(" ")[0],
                    onlyDateOfDay = dateFormat.split(" ")[1],
                    nameOfDay = day.dayOfWeek.toWeekDay(),
                    dayByNumber = dateFormat.split(" ")[2]
                )
            )
        }
        return timeDetectorList.toList()
    }


    //[0, 15 апреля, 15.04.2024, Понедельник]
    //println("123 $mList")
//    Log.d("timeDetector", "$timeDetectorList")
    companion object{
        val RUSSIAN_MONTH_NAME_ABBREVIATED: MonthNames = MonthNames(
            listOf(
                "Янв", "Фев", "Мар", "Апр", "Май", "Июнь",
                "Июль", "Авг", "Сен", "Окт", "Нояб", "Дек"
            )
        )

        val RUSSIAN_MONTH_NAME_FULL: MonthNames = MonthNames(
            listOf(
                "Январь", "Февраль", "Март", "Апрель", "Май", "Июнь",
                "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"
            )
        )
    }
}
